import { Dropdown, DropdownList, DropdownItem } from '@cokitchen/cokitchen-components';
import React, { useState } from 'react';
import { ReactComponent as GlovoIcon } from 'assets/icons/glovo-icon.svg';
import { ReactComponent as ManoIcon } from 'assets/icons/mano-icon.svg';
import ChowdeckIcon from 'assets/images/chowdeck.png';
import { ENUM_BRAND_TYPE } from 'utils/enum';

type Props = {
  onMoveBrand: (type: ENUM_BRAND_TYPE) => void;
};

const MoveBrandMenu = ({ onMoveBrand }: Props) => {
  const [showDropdown, setShowDropdown] = useState(false);

  return (
    <Dropdown
      visible={showDropdown}
      content={
        <div
          onClick={() => setShowDropdown(!showDropdown)}
          className='border border-[#E8E8E8] rounded-full p-2 hover:bg-gray-2'>
          <p>Move</p>
        </div>
      }
      onClickOutside={() => setShowDropdown(false)}
      className='min-w-[199px]'>
      <DropdownList>
        <>
          <DropdownItem onClick={() => onMoveBrand(ENUM_BRAND_TYPE.GLOVO)} className='min-h-[38px]'>
            <div className='flex items-center gap-3 text-sm '>
              <div className='bg-white border-[0.6px] border-[#EAEAEB] rounded-full m-auto py-1 px-1 shadow-md '>
                <GlovoIcon />
              </div>
              <p> Move to Glovo</p>
            </div>
          </DropdownItem>
          <DropdownItem
            className='min-h-[38px]'
            onClick={() => {
              onMoveBrand(ENUM_BRAND_TYPE.CHOWDECK);
            }}>
            <div className='flex gap-3 items-center text-sm'>
              <div className='bg-white border-[0.6px] border-[#EAEAEB] rounded-full m-auto py-1 px-1 shadow-md '>
                <img
                  src={ChowdeckIcon}
                  className='border rounded-full border-[#197B61] w-[19px] h-[19px]'
                />{' '}
              </div>
              <p> Move to Chowdeck</p>
            </div>
          </DropdownItem>

          <DropdownItem className='min-h-[38px] opacity-50'>
            <div className='flex gap-3 items-center text-sm'>
              <div className='bg-white border-[0.6px] border-[#EAEAEB] rounded-full m-aut0 shadow-md '>
                <ManoIcon />
              </div>
              <p> Move to Mano</p>
            </div>
          </DropdownItem>
        </>
      </DropdownList>
    </Dropdown>
  );
};

export default MoveBrandMenu;
